'use client'

import { useEffect } from 'react'

import { FieldTrackingName } from '../constants'
import { useUiStateContext } from '../contexts/UiStateContext'

const useFieldVisibility = ({
  fieldName,
  isVisible,
}: {
  fieldName: FieldTrackingName
  isVisible: boolean
}) => {
  const { updateFieldVisibility } = useUiStateContext()

  useEffect(() => {
    updateFieldVisibility({ fieldName, isVisible })
  }, [updateFieldVisibility, isVisible, fieldName])
}

export default useFieldVisibility
